<template>
  <div :class="['container', { 'container-dark': theme_dark }]">
    
      <div class="top" :style="{ 'background-image': 'url(' + pic_back + ')' }">
        <div class="mask">
            <div class="photo ub ub-ac2">
              <div class="ub ub-pc">
                <div @click="goto_home_page()">
                  <img :src="user.photo" class="avatar"/>
                </div>

                <div class="nike ub ub-ver ub-ac2">
                  <div class="ub ub-pc">
                    <span class="txt">{{ user.nick }}</span>
                    <div v-if="vip_tag != '' && vip_tag == 'SVIP'" class="note-svip ub ub-pc">
                      <img src="../assets/img/new2024/svip-tag.png" alt="">
                      <span>{{ vip_tag }}</span>
                    </div>
                    <div v-if="vip_tag != '' && vip_tag == 'VIP'" class="note-vip ub ub-pc">
                      <img src="../assets/img/new2024/vip-tag.png" alt="">
                      <span>{{ vip_tag }}</span>
                    </div>
                  </div>

                  <div class="ub ub-pc" >
                      <div class="age ub ub-pc" v-if="user.sex == '女生'">
                        <img src="../assets/img/女.png" />
                        <span>{{ user.age_range }}</span>
                      </div>
                    
                      <div class="age ub ub-pc" v-if="user.sex == '男生'">
                        <img src="../assets/img/男.png" />
                        <span>{{ user.age_range }}</span>
                      </div>

                    <div class="location ub ub-ac ub-pc">
                      <span v-if="user.loc_province != '' && user.loc_city != ''">{{user.loc_province.length > 6 ?user.loc_province.substr(0, 5) + "..." : user.loc_province }}&nbsp;{{user.loc_city.length > 6 ?user.loc_city.substr(0, 5) + "..." : user.loc_city }}</span>
                      <span v-if="user.loc_province == '' && user.loc_city == ''">暂无地址</span>
                    </div>

                  </div>
                </div>
              </div>

            </div>

            <div class="ub ub-pc ub-ac2 num">
              <ul class="ub ub-ac2 ub-f1 coinscore">

                <li class="ub ub-ver ub-pc">
                  <span>{{ show_coin }}</span>
                  <span>豪气值</span>
                </li>

                <li class="ub ub-ver ub-pc">
                  <span>{{ show_score }}</span>
                  <span>魅力值</span>
                </li>

                <li class="ub ub-ver ub-pc">
                  <span>{{ user.friend_num }}</span>
                  <span>好友</span>
                </li>
              </ul>

              <ul class="ub ub-pc ub-ae ub-f1 btn">
                <li class="ub ub-pc ub-ac active" v-if="is_sign == 0" @click="goto_Sign()">
                  <span>签到</span>
                </li>

                <li class="ub ub-pc ub-ac active" v-if="user.sex == '男生' && is_sign == 1" @click="goto('task_coin')">
                  <span>赚金币</span>
                </li>
                <li class="ub ub-pc ub-ac active" v-if="user.sex == '女生' && is_sign == 1" @click="goto('task_score')">
                  <span>赚积分</span>
                </li>

                <li class="ub ub-pc active" @click="goto('my_info')">
                    <img src="../assets/img/new2024/edit.png" alt="">
                    <span>编辑资料</span>
                </li>
              </ul>
            </div>
        </div>
      </div>


      <div class="menu ub ub-ver">
        
        <ul class="function ub ub-ac1">
          <li class="ub ub-ver ub-pc" @click="goto('tx2')">
              <div class="item ub ub-pc ub-ac">
                <img class="icon" src="../assets/img/new2024/my-wallet.png" />
              </div>
              <span>我的钱包</span>
            </li>

            <li class="ub ub-ver ub-pc" @click="goto('mycoin')">
              <div class="item ub ub-pc ub-ac">
                <img class="icon" src="../assets/img/new2024/my-coin.png" />
              </div>
              <span>我的金币</span>
            </li >

            <li class="ub ub-ver ub-pc" @click="goto('vip_center')">
              <div class="item ub ub-pc ub-ac">
                <img class="icon" src="../assets/img/new2024/my-vip.png" />
              </div>
              <span>会员中心</span>
            </li>
        </ul>

        <ul>
          <li class="ub ub-pc ub-ac1 item" v-if="user.sex == '女生'" @click="goto('task_score')">
            <img src="../assets/img/new/余额.png"  />
            <span>赚积分</span>
            <div class="ub ub-pc ub-ae ub-f1">
              <span class="note" v-if="chat_mny_score == 0"><span class="set_tips">去设置</span></span>
            </div>
            <img src="../assets/img/箭头.png" />
          </li>
          <li class="line" v-if="user.sex == '女生'"></li>
          
          <li class="ub ub-pc ub-ac1 item" v-if="user.sex == '男生'" @click="goto('task_coin')">
            <img src="../assets/img/new/金额.png"  />
            <span>赚金币</span>
            <div class="ub ub-pc ub-ae ub-f1">
              <span class="note"><span class="set_tips">免费领</span></span>
            </div>
            <img src="../assets/img/箭头.png" />
          </li>
          <li class="line" v-if="user.sex == '男生'"></li>

          <li class="ub ub-pc ub-ac1 item" @click="goto('invite')">
            <img src="../assets/img/new/余额.png"  />
            <span>邀请好友</span>
            <div class="ub ub-pc ub-ae ub-f1">
              <span class="note ub ub-pc">赚收益</span>
            </div>
            <img src="../assets/img/箭头.png" />
          </li>
        </ul>

        <ul>

          <li class="ub ub-pc item" @click="goto('look_people')">
            <img src="../assets/img/new/查找.png" />
            <span class="menu-item-name">寻人区</span>
            <div class="ub ub-ae ub-f1">
              <img src="../assets/img/箭头.png"  />
            </div>
          </li>
          <li class="line"></li>

          <li class="ub ub-pc item" @click="goto_complain()">
            <img src="../assets/img/new/投诉举报.png" />
            <span>用户反馈</span>
            <div class="ub ub-ae ub-f1"></div>
            <img src="../assets/img/箭头.png"  />
          </li>
          <li class="line"></li>

          <li class="ub ub-pc item" @click="goto_chart_admin()">
            <img src="../assets/img/new/通知.png" />
            <span>客服联系</span>
            <div class="ub ub-ae ub-f1"></div>
            <img src="../assets/img/箭头.png"  />
          </li>
          <li class="line"></li>

          <li class="ub ub-pc item" @click="goto('qst')">
            <img src="../assets/img/new/常见问题.png" />
            <span>常见问题</span>
            <div class="ub ub-ae ub-f1"></div>
            <img src="../assets/img/箭头.png"  />
          </li>
          <li class="line"></li>

          <li class="ub ub-pc item" @click="goto('sys_set')">
            <img src="../assets/img/new/系统设置.png" />
            <span>系统设置</span>
            <div class="ub ub-ae ub-f1 version">版本:{{ app_version }}</div>
            <img src="../assets/img/箭头.png"  />
          </li>

          <li class="ub ub-pc item" @click="goto('get_into')" v-if="false">
            <img src="../assets/img/new/测试.png" class="menu-item-img" />
            <span>Test</span>
            <div class="ub ub-ae ub-f1"></div>
            <img src="../assets/img/箭头.png"  />
          </li>
        </ul>
        <div style="height: 3rem;"></div>
      </div>

    <sign_boy ref="myForm_boySign" @SignState="getSignState"></sign_boy>
    <sign_girl ref="myForm_girlSign" @SignState="getSignState"></sign_girl>
    <dlg ref="myForm_2"></dlg>
  </div>
</template>

<script>
import { mapMutations, mapActions } from "vuex";
import * as tool from "../api/common";
import Form_BoySign from "../components/Sign.vue";
import Form_GirlSign from "../components/Sign_Girl.vue";
import Form from "../components/Form.vue";
export default {
  components: {
    sign_boy: Form_BoySign,
    sign_girl: Form_GirlSign,
     dlg: Form
  },
  data() {
    return {
      user: {
        photo: require("../assets/img/头像.jpg"),
        nick: "***",
        sex: "女生",
        age_range: "18-23岁",
        loc_province: "**省",
        loc_city: "**市",
        loc_area: "**区",
        inst_tag: ["***", "***"],
        coin_left: 0,
        score_total: 0,
        coin_total: 0,
        friend_num: 0,
      },

      show_coin: 0,
      show_score: 0,

      pic_back: "",

      vip_tag: "",

      app_version: "",

      is_sign: 0,

      theme_dark: false,

      chat_mny_score: 0
    };
  },
  mounted() {
    //切换深色模式
    this.theme_dark = tool.is_theme_dark(this);
    
    this.init_user();
    this.init_sign();
  },
  methods: {
    ...mapMutations(["get", "post"]), //引入方法
    ...mapActions(["act_get_userinfo"]), //引入方法

    init_user() {
      this.app_version = this.$store.state.app_version;
      var uid = this.$store.state.uid;
      var self = this;

      self.act_get_userinfo({
        uid: uid,
        success: function (u) {
          // console.log(JSON.stringify(u));
          self.user.uid = u.uid;
          self.user.photo = u.photo;
          self.user.nick = u.nick;// u.nick.length > 6 ? u.nick.substr(0, 5) + "..." : u.nick;
           
          self.user.sex = u.sex;
          self.user.age_range = u.age_range;
          self.user.loc_province = u.loc_province;
          self.user.loc_city = u.loc_city;
          self.user.loc_area = u.loc_area;
          self.user.inst_tag = u.inst_tag.split("|");
          self.user.coin_left = u.coin_left;
          self.user.score_total = u.score_total;
          self.user.coin_total = u.coin_total;
          self.user.friend_num = u.friend_num;
          self.vip_tag = u.vip_tag;

          self.show_coin = u.coin_total;
          self.show_score = u.score_total;
          self.pic_back = u.pic_back;
          self.chat_mny_score = u.chat_mny_score;

          if (u.show_coin > 0) {
            self.show_coin = u.show_coin;
          }
          if (u.show_score > 0) {
            self.show_score = u.show_score;
          }

          if (self.pic_back == "") {
            self.pic_back = "http://appdata.jscx666.cn/photo/bg_img/1.jpg";
          }
        },
      });


    },

    init_sign() {
      var uid = this.$store.state.uid;
      var my_sign = this.$store.state.http_cache.my_sign;
      if (my_sign.is_sign != 99) {
        this.is_sign = my_sign.is_sign;
        return false;
      }
      
      var self = this;
      this.get({
        url: "/App/Is_Sign/?uid=" + uid,
        success: function (data) {
          var obj = {
            is_sign: data.state,
            sign_count: my_sign.sign_count
          }
          self.$store.commit("set_http_cache", {my_sign: obj});

          self.is_sign = parseInt(data["state"]);
        },
        error: function (err) {},
      });
    },

    goto_home_page() {
      var uid = this.$store.state.uid;
      this.$router.push({ name: "home_page", params: { topic_uid: uid } });
    },

    goto_Sign() {
      var skipWxCheck = this.$store.state.skipWxCheck;
      if (!skipWxCheck) {
        //判断是否关注公众号，没有关注弹关注提示
        var wxInfo = this.$store.state.wxInfo;
          if (wxInfo == "") {
            this.show_sys_GuanzhuWx("签到");
            return false;
          }
      }

      var my_sign = this.$store.state.http_cache.my_sign;
      if (my_sign.is_sign != 99) {
        this.$refs.myForm_boySign.show(my_sign.is_sign);
        return false;
      } else {
        this.$refs.myForm_boySign.show(this.is_sign);
      }
      
    },

    goto_girlSign() {
      var skipWxCheck = this.$store.state.skipWxCheck;
      if (!skipWxCheck) {
        //判断是否关注公众号，没有关注弹关注提示
        var wxInfo = this.$store.state.wxInfo;
          if (wxInfo == "") {
            this.show_sys_GuanzhuWx("签到");
            return false;
          }
      }

      var my_sign = this.$store.state.http_cache.my_sign;
      if (my_sign.is_sign != 99) {
        this.$refs.myForm_girlSign.show(my_sign.is_sign);
        return false;
      } else {
        this.$refs.myForm_girlSign.show(this.is_sign);
      }
      
    },

    goto(name) {
      this.$router.push({ name: name });
    },

    //获取子组件中的签到状态
    getSignState(sign_state) {
      this.is_sign = sign_state;
    },

    goto_complain() {
      var skipWxCheck = this.$store.state.skipWxCheck;
      if (!skipWxCheck) {
        //检测是否关注公众号
        var wxInfo = this.$store.state.wxInfo;
        if(wxInfo == ""){
          this.show_sys_GuanzhuWx("投诉举报");
          return false;
        }
      }
      
      this.$router.push({ name: "complain" });
    },

    goto_chart_admin() {
      var sysdic = this.$store.state.sysdic;
      if(sysdic) {
        var xhc_admin_uid = sysdic.xhc_admin_uid;
        this.$router.push({ name: "chart_admin", params: { uid: xhc_admin_uid } });
      } else {
        this.$toast.center('未获取到官方客服uid');
      }
    },

    //关注公众号提示
    show_sys_GuanzhuWx(txt) {
      var qrcode_url = require("../assets/img/qrcode_xhc.jpg");
      var gzh_name = "小火柴";
      //加载dic信息
      var sysdic = this.$store.state.sysdic;
      if (sysdic) {
        qrcode_url = sysdic.wx_gzh_qrcode;
        gzh_name = sysdic.wx_gzh_name;
      }

      var h = '<div style="line-height:1.6em;font-size:.85em;"><label style=" font-weight: bold;font-size:1.1em;">当前版本过低，<label style=" font-weight: bold;font-size:1.1em;color:red;">"'+txt+'"</label>功能无法使用</label>，请关注公众号【<a style="color: rgb(186, 97, 255)">'+ gzh_name +'<a/>】，开启'+txt+'功能。<div>' +
        '<div class="ub ub-ac ub-pc dlg-img"><img src="' + qrcode_url + '" style="margin: 1rem 0"/></div>' +
        '<div style="line-height:1.6em; text-align:center;">长按开启'+txt+'功能<div>';
      this.$refs.myForm_2.show(h, {
        type: "alert",
        confirmText: "长按上方二维码",
        titleText: "温馨提示",
        data: "",
      });

    }
  },
};
</script>

<style lang="scss" scoped>
.container  {
  min-height: 100vh;
  background-color: #f2f2f2;
}

.top {
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    .mask {
      padding: 1rem 1rem 0 1rem;
      background-color: #333;
      height: 16rem;
      background-color: rgba(51, 51, 51, 0.5);
      .photo {
        margin-top: 6.4rem;
        img.avatar {
          width: 3.75rem;
          height: 3.75rem;
          border-radius: 50%;
          border: 1px solid #dcdcdc;
          pointer-events: none;
        }
        .nike {
          font-size: 1rem;
          margin-left: 0.6rem;
          span.txt {
            display: inline-block;
            color: #fff;
            font-size: 0.95rem;
          }
          .note-svip {
            height: 0.87rem;
            padding: 0 0.2rem;
            margin-left: 0.2rem;
            border-radius: 0.2rem;
            background-color: #F1B232;
            color: #FFEEBB;
            span {
              margin-left: 0.1rem;
              font-size: 0.75rem;
            }
            img {
              width: 0.8rem;
              height: 0.8rem;
            }
          }
          .note-vip {
            height: 0.87rem;
            padding: 0 0.2rem;
            margin-left: 0.2rem;
            border-radius: 0.2rem;
            background-color: #FF0000;
            color: #FFFFFF; 
            span {
              margin-left: 0.1rem;
              font-size: 0.65rem;
            }
            img {
              width: 0.8rem;
              height: 0.8rem;
            }
          }

          .age {
            padding: 0.1rem 0.3rem;
            margin-top: 0.5rem;
            border-radius: 0.6rem;
            background-color: transparent;
            color: #fff;
            border: 1px solid #FFFF;
            img {
              width: 0.8rem;
              height: 0.8rem;
              pointer-events: none;
            }
            span {
              margin-left: 0.1rem;
              font-size: 0.6rem;
            }
          }
        .location {
            padding: 0.2rem 0.3rem;
            margin-top: 0.5rem;
            margin-left: 0.3rem;
            border-radius: 0.8rem;
            background-color: #FE9CC0;
            font-size: 0.6rem;
            color: #fff;
        }
      }
      }
      .num {
        margin-top: 1rem;
        ul.coinscore {
          span {
            color: #fff;
            font-weight: 600;
            font-size: 0.75rem;
          }
        }
        ul.btn {
        li.active {
          margin-left: 1rem;
          padding: 0.5rem 1rem;
          border-radius: 1rem;
          border: 1px solid #FE9CC0;
          color: #FFFF;
          background: linear-gradient(86deg, rgba(162, 100, 231, 0.4), rgba(254, 156, 192, 0.4)) ;
          img {
            margin-top: 0.1rem;
          }
          span {
            font-size: 0.6rem;
          }
        }
        .no-sign {
          margin-left: 1rem;
          padding: 0.5rem 1rem;
          border-radius: 1rem;
          border: 1px solid #999;
          color: #fff;
          
          font-size: 0.75rem;
        }
        }
      }
    }
}

.menu {
  padding: 0.8rem 0.8rem;
  ul {
    background-color: #FDFDFD;
    padding: 0 0.5rem;
    margin-bottom: 0.8rem;
    border-radius: 0.5rem;
    .item {
      height: 3rem;
      .vip-block {
        span {
          margin-left: 0.2rem;
        }
      }
      .vip-span {
        color: #BA61FF;
      }
      .svip-span {
        margin-right: 0.3rem;
        color: #F5C636;
      }
      img {
        width: 1.2rem;
        height: 1.2rem;
      }
      span {
        margin-left: 1rem;
        font-size: 0.9rem;
      }
      .note {
        margin-right: 0.3rem;
        color: #E13366;
        font-size: 0.9rem;
      }
      .note-coin {
        color: #ffd700;
      }
      .set_tips {
        font-size: 0.9rem;
        color: #ef4b4b;
      }
      .version {
        font-size: 0.9rem;
        color: #666;
      }
    }
  }
  .line {
    margin: 0 0.8rem;
    border-top: 1px solid #EEEEEE;
  }

  .function {
        padding: 0.8rem 0.8rem;
        .item {
          width: 2.75rem;
          height: 2.75rem;
          border-radius: 50%;
        }
        .icon {
          width: 1.4rem;
          height: 1.4rem;
        }
        span {
          font-size: 0.9rem;
          margin-top: 0.8rem;
        }
      }
      .function li:nth-child(1) .item {
        background-color: #ba61ff;
      }

      .function li:nth-child(2) .item {
        background-color: #ffd700;
      }

      .function li:nth-child(3) .item {
        background-color: #FF0000;
      }
}

.container-dark {
  min-height: 100vh;
  background-color: #2F2E33;
  .menu ul {
    background-color: #38363f;
    li.item {
      color: #DFDFDF;
    }
    
  }
  .line {
    border-top: 1px solid #404040;
  }
  .function {
    span {
      color: #DFDFDF;
    }
  }
}
</style>
